
























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { News } from '@/types';

@Component
export default class Footer extends Vue {
  @Getter public news: News;

  public created() {
    this.$store.dispatch('fetchNewsBanner');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer/Footer.vue